import React from "react";

import ExecutiveDashboard from "./ExecutiveDashboard";
import SalesDashboard from "./SalesDashboard";
import StockDashboard from "./StockDashboard";

export type DashboardRefreshMode = "auto" | "manual";

export interface DashboardRegistryItem {
  key: string;
  label: string;
  title: string;
  component: React.ComponentType<any>;
  refreshMode: DashboardRefreshMode;
  refreshIntervalSec?: number;
  pinned?: boolean;
  category?: "core" | "finance" | "operations" | "governance";
  description?: string;
}

export const dashboardRegistry: DashboardRegistryItem[] = [
  {
    key: "executive",
    label: "Executive",
    title: "Executive Dashboard",
    component: ExecutiveDashboard,
    refreshMode: "auto",
    refreshIntervalSec: 300,
    pinned: true,
    category: "core",
    description: "Summary view for executive management.",
  },
  {
    key: "sales",
    label: "Sales",
    title: "Sales Dashboard",
    component: SalesDashboard,
    refreshMode: "auto",
    refreshIntervalSec: 300,
    pinned: true,
    category: "core",
    description: "Sales pipeline, payments, follow-ups, targets, and trends.",
  },
  {
    key: "stock",
    label: "Stock",
    title: "Stock Dashboard",
    component: StockDashboard,
    refreshMode: "auto",
    refreshIntervalSec: 300,
    pinned: true,
    category: "operations",
    description: "Stock balances, low-stock items, movement, adjustments, and aging.",
  },
];

export const defaultDashboardKey = "executive";

export function getDashboardByKey(key?: string) {
  return dashboardRegistry.find((item) => item.key === key) || dashboardRegistry[0];
}
